import React, { useState } from 'react';
import { Button, Grid, Typography, Container, Box, CircularProgress } from '@material-ui/core';
import Layout from '../Layout';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UploadAssetMasterData, UploadITMSFile, UploadSapDataAuto, UploadVendorMasterData } from '../../ReduxStore/MastertableSlice';




const DataUpload = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' },
        { label: 'Data Management', href: '/data-management' }
    ];

    const [postLoading, setPostLoading] = useState(false);
    const [vendorUpload, setVendorUpload] = useState(false);
    const [itmsUpload, setITMSUpload] = useState(false);
    const [assetMasterFile, setAssetMasterFile] = useState(null);
    const [vendorMasterFile, setVendorMasterFile] = useState(null);
    const [itmsFile, setITMSFile] = useState(null);

    const allowedExtensions = ["xls", "xlsx"];

    const handleAssetMaster = (e) => {
        const file = e.target.files[0];

        const fileName = file.name;
        // Validate for double extensions
        const fileParts = fileName.split('.');
        if (fileParts.length !== 2) {
            toast.info('Invalid file name. Ensure it has only one valid extension.');
            return;
        }

        // Check for invalid file names (e.g., hidden files starting with ".")
        if (file.name.startsWith(".")) {
            toast.info(`File "${file.name}" is not allowed.`);
            return;
        }

        // Get file extension
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Validate file extension
        if (!allowedExtensions.includes(fileExtension)) {
            toast.info(`File "${file.name}" has an invalid extension.`);
            return;
        }

        if (file) {
            setAssetMasterFile(file);
        }
    };

    const handleITMSFile = (e) => {
        const file = e.target.files[0];
        const fileName = file.name;
        // Validate for double extensions
        const fileParts = fileName.split('.');
        if (fileParts.length !== 2) {
            toast.info('Invalid file name. Ensure it has only one valid extension.');
            return;
        }

        // Check for invalid file names (e.g., hidden files starting with ".")
        if (file.name.startsWith(".")) {
            toast.info(`File "${file.name}" is not allowed.`);
            return;
        }
        // Get file extension
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Validate file extension
        if (!allowedExtensions.includes(fileExtension)) {
            toast.info(`File "${file.name}" has an invalid extension.`);
            return;
        }

        if (file) {
            setITMSFile(file);
        }
    };

    const UploadAssetMaster = async () => {
        if (assetMasterFile) {
            const formData = new FormData();
            formData.append(assetMasterFile.name, assetMasterFile);
            try {
                setPostLoading(true)
                const action = dispatch(UploadAssetMasterData(formData));
                const res = await action.unwrap();
                console.log("res from pv log:", res);
                if (res.StatusCode === 201) {
                    setPostLoading(false)
                    toast.success("Asset Master Uploaded!");
                    setAssetMasterFile(null)
                    // setTimeout(() => {
                    //     navigate("/asset-declaration-history");
                    // }, 2000);
                } else {
                    toast.error("Something went wrong!")
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
                setAssetMasterFile(null)
            }
        } else {
            toast.warning(`No file selected`);
        }
    };

    const handleVendorMaster = (e) => {
        const file = e.target.files[0];

        const fileName = file.name;
        // Validate for double extensions
        const fileParts = fileName.split('.');
        if (fileParts.length !== 2) {
            toast.info('Invalid file name. Ensure it has only one valid extension.');
            return;
        }

        // Check for invalid file names (e.g., hidden files starting with ".")
        if (file.name.startsWith(".")) {
            toast.info(`File "${file.name}" is not allowed.`);
            return;
        }

        // Get file extension
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Validate file extension
        if (!allowedExtensions.includes(fileExtension)) {
            toast.info(`File "${file.name}" has an invalid extension.`);
            return;
        }

        if (file) {
            setVendorMasterFile(file);
        }
    };


    const UploadVendorMaster = async () => {
        // if (!selectedFile) return;
        if (vendorMasterFile) {
            const formData = new FormData();
            formData.append(vendorMasterFile.name, vendorMasterFile);
            try {
                setVendorUpload(true)
                const action = dispatch(UploadVendorMasterData(formData));
                const res = await action.unwrap();
                if (res.StatusCode === 201) {
                    setVendorUpload(false)
                    toast.success("Vendor Master Uploaded!");
                    toast.success(res.result);
                    setVendorMasterFile(null)
                    // setTimeout(() => {
                    //     navigate("/asset-declaration-history");
                    // }, 2000);
                } else {
                    toast.error("Something went wrong!")
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setVendorUpload(false)
            }
        } else {
            toast.warning(`No file selected`);
        }
    };

    const UploadITMSData = async () => {
        // if (!selectedFile) return;
        if (itmsFile) {
            const formData = new FormData();
            formData.append(itmsFile.name, itmsFile);
            try {
                setVendorUpload(true)
                const action = dispatch(UploadITMSFile(formData));
                const res = await action.unwrap();
                if (res.StatusCode === 201) {
                    setITMSUpload(false)
                    toast.success("ITMS Data Uploaded!");
                    // toast.success(res.result);
                    setITMSFile(null)
                    // setTimeout(() => {
                    //     navigate("/asset-declaration-history");
                    // }, 2000);
                } else {
                    toast.error("Something went wrong!")
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setITMSUpload(false)
            }
        } else {
            toast.warning(`No file selected`);
        }
    };

    const initiateSapDataScript = async (param = "") => {
        toast.info("Sap Data Uploading Started");
        try {
            // setPostLoading(true)
            const action = dispatch(UploadSapDataAuto(param));
            const res = await action.unwrap();
            if (res.StatusCode === 201) {
                setPostLoading(false)
                toast.success("File Upload Done");
            } else {
                toast.error("Something went wrong!")
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            // toast.error(error.message || "Something went wrong!");
        } finally {
            // setPostLoading(false)
        }

    };

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Data Management
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Upload Data" />
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Upload Asset Master
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <input
                                type="file"
                                hidden
                                id="AssetMaster"
                                accept=".xls,.xlsx" // Accept Excel files
                                onChange={handleAssetMaster}
                            />
                            <label htmlFor="AssetMaster">
                                <Button variant="contained" component="span" color="primary" >
                                    Select File
                                </Button>
                            </label>
                            {assetMasterFile && (
                                <>
                                    <Box mt={2}>
                                        <Typography variant="body1" gutterBottom>
                                            Selected File: {assetMasterFile.name}
                                        </Typography>
                                    </Box>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={UploadAssetMaster}
                                        style={{ marginTop: '10px' }}
                                        startIcon={postLoading && <CircularProgress size={20} />}
                                        disabled={postLoading}
                                    >
                                        {postLoading ? 'Uploading...' : 'Upload File'}
                                    </Button>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Upload Vendor Master
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <input
                                type="file"
                                hidden
                                id="vendorMaster"
                                accept=".xls, .xlsx,"
                                onChange={handleVendorMaster}
                            />
                            <label htmlFor="vendorMaster">
                                <Button variant="contained" component="span" color="primary">
                                    Select File
                                </Button>
                            </label>
                            {vendorMasterFile && (
                                <>
                                    <Box mt={2}>
                                        <Typography variant="body1" gutterBottom>
                                            Selected File: {vendorMasterFile.name}
                                        </Typography>
                                    </Box>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={UploadVendorMaster}
                                        style={{ marginTop: '10px' }}
                                        startIcon={vendorUpload && <CircularProgress size={20} />}
                                        disabled={vendorUpload}
                                    >
                                        {vendorUpload ? 'Uploading...' : 'Upload File'}
                                    </Button>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Upload ITMS Data
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <input
                                type="file"
                                hidden
                                id="itmsfile"
                                accept=".xls, .xlsx,"
                                onChange={handleITMSFile}
                            />
                            <label htmlFor="itmsfile">
                                <Button variant="contained" component="span" color="primary">
                                    Select File
                                </Button>
                            </label>
                            {itmsFile && (
                                <>
                                    <Box mt={2}>
                                        <Typography variant="body1" gutterBottom>
                                            Selected File: {itmsFile.name}
                                        </Typography>
                                    </Box>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={UploadITMSData}
                                        style={{ marginTop: '10px' }}
                                        startIcon={itmsUpload && <CircularProgress size={20} />}
                                        disabled={itmsUpload}
                                    >
                                        {itmsUpload ? 'Uploading...' : 'Upload File'}
                                    </Button>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Box>

                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Initiate Uploading SAP Data PV
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => initiateSapDataScript()}
                                style={{ marginTop: '10px' }}
                            // startIcon={postLoading && <CircularProgress size={20} />}
                            // disabled={postLoading}
                            >
                                Initiate PV Uploading
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Initiate Uploading SAP Data EV
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => initiateSapDataScript('?ev_data=true')}
                                style={{ marginTop: '10px' }}
                            // startIcon={postLoading && <CircularProgress size={20} />}
                            // disabled={postLoading}
                            >
                                Initiate EV Uploading
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default DataUpload;
